/* istanbul ignore file */
import React from 'react';
import { Modal } from '@interstate/components/Modal';

export const ProposalRemoveDrawer = ({ hideHandler, removeHandler }: { hideHandler: () => void; removeHandler: () => void }) => {
    return (
        <Modal
            show
            size="large"
            header="Delete Printing Proposal"
            onHide={hideHandler}
            footer={{
                primary: {
                    label: 'Delete',
                    action: removeHandler,
                    'data-testid': 'confirm-delete-proposal',
                    buttonStyle: 'primary'
                },
                options: [
                    {
                        label: 'Cancel',
                        action: hideHandler,
                        'data-testid': 'cancel-delete-proposal',
                        buttonStyle: 'tertiary'
                    }
                ]
            }}
        >
            <>Are you sure you want to delete this printing proposal?</>
        </Modal>
    );
};
